(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-generique"] && !Shopify.designMode) return;
  try {
    
(function(){
  var genericProductSections = document.querySelectorAll('.alhel-pdp-wrap[id^="AlhelPdp-"]');
  var root = genericProductSections[genericProductSections.length - 1];
  if (!root || root.dataset.alhelInitialized === 'true') return;
  root.dataset.alhelInitialized = 'true';

  function parseJSON(value, fallback){
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  var variantsData = parseJSON(root.dataset.variants || '[]', []);
  var variantMediaMap = {};
  root.querySelectorAll('[data-variant-media-map] [data-variant-id]').forEach(function(item){
    if (item.dataset.variantMediaId){
      variantMediaMap[String(item.dataset.variantId)] = String(item.dataset.variantMediaId);
    }
  });
  var optionsCount = parseInt(root.dataset.optionsCount || '0', 10);
  var selectedOptions = parseJSON(root.dataset.selectedOptions || '[]', []);
  var basePrice = parseInt(root.dataset.basePrice || '0', 10);
  var cartUrl = root.dataset.cartUrl || '/cart';

  root.querySelectorAll('.product-video-slide').forEach(function(slide){
    var video = slide.querySelector('video');
    var playButton = slide.querySelector('.product-video-play');
    if (!video || !playButton) return;
    video.controls = false;
    playButton.addEventListener('click', function(){
      video.play().then(function(){ playButton.classList.add('is-hidden'); }).catch(function(){});
    });
    video.addEventListener('pause', function(){
      playButton.classList.remove('is-hidden');
    });
    video.addEventListener('ended', function(){ playButton.classList.remove('is-hidden'); });
  });

  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }

  function findVariant(){
    return variantsData.find(function(v){
      for (var i=0;i<optionsCount;i++){ if (v.options[i] !== selectedOptions[i]) return false; }
      return true;
    });
  }

  function showVariantMedia(variant, smooth){
    if (!variant) return;
    var mediaId = variantMediaMap[String(variant.id)];
    if (!mediaId) return;

    var track = root.querySelector('#gallerySlides');
    var slide = track ? track.querySelector('[data-media-id="' + mediaId + '"]') : null;
    if (!track || !slide) return;

    // Lors d'un choix effectué par la cliente, remonte immédiatement au
    // carrousel pour rendre le changement de photo visible. Le chargement
    // initial utilise smooth=false et ne déplace donc pas la page.
    if (smooth !== false){
      var gallery = root.querySelector('.pdp-gallery');
      if (gallery){
        gallery.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    }

    track.scrollTo({
      left: slide.offsetLeft - track.offsetLeft,
      behavior: smooth === false ? 'auto' : 'smooth'
    });
  }

  function updateVariantUI(){
    var v = findVariant();
    var btn = root.querySelector('#addToCartBtn');
    var stickyBtn = root.querySelector('#stickyAddToCartBtn');
    var priceEl = root.querySelector('#pdpPrice');
    if (v){
      basePrice = v.price;
      showVariantMedia(v, true);
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn){ btn.dataset.variantId = v.id; btn.disabled = !v.available; btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      if (stickyBtn){ stickyBtn.dataset.variantId = v.id; stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Ajouter' : 'Épuisé'; }
    } else if (btn){
      btn.disabled = true; btn.textContent = 'Indisponible dans cette combinaison';
      if (stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Indisponible'; }
    }
    updateBundlePrices();
    updateTotal();
  }

  root.querySelectorAll('[data-option-index]').forEach(function(group){
    var idx = parseInt(group.dataset.optionIndex, 10);
    group.querySelectorAll('.pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        group.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        selectedOptions[idx] = pill.dataset.value;
        updateVariantUI();
      });
    });
  });

  var currentVersion = null;
  var versionGroup = root.querySelector('#versionChoice');
  if (versionGroup){
    var firstPill = versionGroup.querySelector('.pill');
    if (firstPill) currentVersion = firstPill.dataset.value;
    versionGroup.querySelectorAll('.pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        versionGroup.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        currentVersion = pill.dataset.value;
      });
    });
  }

  var selectedQty = 1;
  var discountPercent = parseInt(root.dataset.discountPercent || '5', 10);
  function updateBundlePrices(){
    root.querySelectorAll('.bundle-tier').forEach(function(tier){
      var qty = parseInt(tier.dataset.qty, 10);
      var raw = basePrice * qty;
      var oldEl = tier.querySelector('[data-price-old]');
      var priceEl = tier.querySelector('[data-price]');
      if (qty === 3){
        var discounted = Math.round(raw * (100 - discountPercent) / 100);
        if (oldEl) oldEl.textContent = money(raw);
        if (priceEl) priceEl.textContent = money(discounted);
      } else if (priceEl) {
        priceEl.textContent = money(raw);
      }
    });
  }
  root.querySelectorAll('.bundle-tier').forEach(function(tier){
    tier.addEventListener('click', function(){
      root.querySelectorAll('.bundle-tier').forEach(function(t){ t.classList.remove('selected'); });
      tier.classList.add('selected');
      selectedQty = parseInt(tier.dataset.qty, 10);
      updateTotal();
    });
  });

  function updateTotal(){
    var totalEl = root.querySelector('#pdpTotal');
    var stickyPriceEl = root.querySelector('#stickyBarPrice');
    var raw = basePrice * selectedQty;
    if (selectedQty === 3){ raw = Math.round(raw * (100 - discountPercent) / 100); }
    if (totalEl) totalEl.textContent = money(raw);
    if (stickyPriceEl) stickyPriceEl.textContent = money(raw);
  }

  root.querySelectorAll('.acc-head').forEach(function(head){
    head.addEventListener('click', function(){
      var isOpen = head.getAttribute('aria-expanded') === 'true';
      var panel = root.querySelector('[data-acc-panel="'+head.dataset.acc+'"]');
      root.querySelectorAll('.acc-head').forEach(function(h){ h.setAttribute('aria-expanded','false'); });
      root.querySelectorAll('.acc-panel').forEach(function(p){ p.style.maxHeight = null; });
      if (!isOpen && panel){ head.setAttribute('aria-expanded','true'); panel.style.maxHeight = panel.scrollHeight + 'px'; }
    });
  });

  // Galerie principale : slides page par page, points, flèches desktop
  function setupCarousel(track, prevBtn, nextBtn, dotsContainer){
    if (!track) return;
    function currentIndex(){ return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function pauseInactiveVideos(){
      var activeIndex = currentIndex();
      Array.prototype.forEach.call(track.children, function(slide, index){
        if (index === activeIndex) return;
        slide.querySelectorAll('video').forEach(function(video){
          if (!video.paused) video.pause();
        });
        slide.querySelectorAll('iframe').forEach(function(frame){
          if (!frame.contentWindow) return;
          frame.contentWindow.postMessage(JSON.stringify({ event:'command', func:'pauseVideo', args:'' }), '*');
          frame.contentWindow.postMessage({ method:'pause' }, '*');
        });
      });
    }
    function updateArrows(){
      if (!prevBtn || !nextBtn) return;
      var idx = currentIndex();
      var lastIdx = track.children.length - 1;
      prevBtn.classList.toggle('is-disabled', idx <= 0);
      nextBtn.classList.toggle('is-disabled', idx >= lastIdx);
    }
    function goTo(index){
      var maxIndex = track.children.length - 1;
      var safeIndex = Math.max(0, Math.min(index, maxIndex));
      var slide = track.children[safeIndex];
      if (slide) track.scrollTo({ left:slide.offsetLeft - track.offsetLeft, behavior:'smooth' });
      window.setTimeout(updateArrows, 350);
    }
    if (prevBtn) prevBtn.addEventListener('click', function(){ goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ goTo(currentIndex() + 1); });

    var dotEls = null;
    if (dotsContainer){
      dotsContainer.innerHTML = '';
      Array.prototype.forEach.call(track.children, function(_, i){
        var dot = document.createElement('span');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', function(){ goTo(i); });
        dotsContainer.appendChild(dot);
      });
      dotEls = dotsContainer.querySelectorAll('.dot');
      track.addEventListener('scroll', function(){
        var idx = currentIndex();
        dotEls.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
        updateArrows();
      }, { passive:true });
    }
    track.addEventListener('scroll', pauseInactiveVideos, { passive:true });
    updateArrows();
    window.addEventListener('resize', updateArrows);
  }

  // Lien avis au-dessus du titre : défilement doux vers les preuves clientes.
  var reviewsLink = root.querySelector('.see-reviews-link');
  if (reviewsLink){
    reviewsLink.addEventListener('click', function(e){
      var target = root.querySelector(reviewsLink.getAttribute('href'));
      if (target){
        e.preventDefault();
        target.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    });
  }

  setupCarousel(
    root.querySelector('#gallerySlides'),
    root.querySelector('#galleryPrev'),
    root.querySelector('#galleryNext'),
    root.querySelector('#galleryDots')
  );
  showVariantMedia(findVariant(), false);
  setupCarousel(
    root.querySelector('#reviewsGrid'),
    root.querySelector('#reviewsPrev'),
    root.querySelector('#reviewsNext'),
    root.querySelector('#reviewsDots')
  );

  var addBtn = root.querySelector('#addToCartBtn');
  var csOverlay = root.querySelector('#csModalOverlay');

  function openCartDrawer(){
    if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function'){
      return Shopify.actions.openCart();
    }

    var cartDrawer = document.querySelector('cart-drawer-component');
    var themeDrawer = cartDrawer && cartDrawer.closest('theme-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function'){
      themeDrawer.open();
      return Promise.resolve();
    }

    console.warn('[Alhel] Le tiroir du panier est indisponible.');
    return Promise.reject(new Error('Le tiroir du panier est indisponible.'));
  }

  function performAddToCart(btn, onDone){
    var variantId = btn.dataset.variantId || (findVariant() || {}).id;
    if (!variantId) return;
    var items = [{ id: variantId, quantity: selectedQty, properties: {} }];
    if (currentVersion) items[0].properties['Objectif'] = currentVersion;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Ajout en cours...';

    var shopifyActions = window.Shopify && Shopify.actions;
    var addRequest;

    if (shopifyActions && typeof shopifyActions.updateCart === 'function'){
      var lines = items.map(function(item){
        var line = {
          merchandiseId: String(item.id),
          quantity: item.quantity || 1
        };

        var attributes = Object.keys(item.properties || {})
          .filter(function(key){
            return item.properties[key] !== null && item.properties[key] !== '';
          })
          .map(function(key){
            return { key:key, value:String(item.properties[key]) };
          });

        if (attributes.length) line.attributes = attributes;
        return line;
      });

      addRequest = shopifyActions.updateCart(
        { lines:lines },
        { event:{ context:'product' } }
      ).then(function(result){
        if (result && result.userErrors && result.userErrors.length){
          throw new Error(result.userErrors[0].message || 'Ajout au panier impossible.');
        }
        return result;
      });
    } else {
      addRequest = fetch(
        (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js',
        {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({ items:items })
        }
      ).then(function(response){
        if (!response.ok) throw new Error('Ajout au panier impossible.');
        return response.json();
      });
    }

    addRequest
      .then(function(){
        btn.disabled = false;
        btn.textContent = originalText;
        if (onDone) onDone();
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  if (addBtn){
    addBtn.addEventListener('click', function(){
      performAddToCart(addBtn, function(){
        if (csOverlay){ csOverlay.classList.add('open'); }
        else { openCartDrawer(); }
      });
    });
  }

  var stickyBtn = root.querySelector('#stickyAddToCartBtn');
  if (stickyBtn && addBtn){
    stickyBtn.addEventListener('click', function(){
      stickyBtn.dataset.variantId = addBtn.dataset.variantId;
      performAddToCart(stickyBtn, function(){
        if (csOverlay){ csOverlay.classList.add('open'); }
        else { openCartDrawer(); }
      });
    });
  }

  // Barre sticky mobile : apparaît quand le bouton principal sort de l'écran
  var stickyBar = root.querySelector('#alhelStickyBar');
  if (stickyBar && addBtn && 'IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(addBtn);
  }

  if (csOverlay){
    var csClose = root.querySelector('#csModalClose');
    var csContinue = root.querySelector('#csContinue');
    var csOpenCart = root.querySelector('#csOpenCart');
    if (csClose) csClose.addEventListener('click', function(){ csOverlay.classList.remove('open'); });
    if (csContinue) csContinue.addEventListener('click', function(){ csOverlay.classList.remove('open'); });
    if (csOpenCart) csOpenCart.addEventListener('click', function(){
      csOverlay.classList.remove('open');
      openCartDrawer();
    });
    csOverlay.addEventListener('click', function(e){ if (e.target === csOverlay) csOverlay.classList.remove('open'); });
  }

  updateBundlePrices();
  updateTotal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pochette-coran-personnalisee"] && !Shopify.designMode) return;
  try {
    
(function(){
  var genericProductSections = document.querySelectorAll('.alhel-pdp-wrap[id^="AlhelPdp-"]');
  var root = genericProductSections[genericProductSections.length - 1];
  if (!root || root.dataset.alhelInitialized === 'true') return;
  root.dataset.alhelInitialized = 'true';

  function parseJSON(value, fallback){
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  var variantsData = parseJSON(root.dataset.variants || '[]', []);
  var variantMediaMap = {};
  root.querySelectorAll('[data-variant-media-map] [data-variant-id]').forEach(function(item){
    if (item.dataset.variantMediaId){
      variantMediaMap[String(item.dataset.variantId)] = String(item.dataset.variantMediaId);
    }
  });
  var optionsCount = parseInt(root.dataset.optionsCount || '0', 10);
  var selectedOptions = parseJSON(root.dataset.selectedOptions || '[]', []);
  var basePrice = parseInt(root.dataset.basePrice || '0', 10);
  var cartUrl = root.dataset.cartUrl || '/cart';

  root.querySelectorAll('.product-video-slide').forEach(function(slide){
    var video = slide.querySelector('video');
    var playButton = slide.querySelector('.product-video-play');
    if (!video || !playButton) return;
    video.controls = false;
    playButton.addEventListener('click', function(){
      video.play().then(function(){ playButton.classList.add('is-hidden'); }).catch(function(){});
    });
    video.addEventListener('pause', function(){
      playButton.classList.remove('is-hidden');
    });
    video.addEventListener('ended', function(){ playButton.classList.remove('is-hidden'); });
  });

  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }

  function findVariant(){
    return variantsData.find(function(v){
      for (var i=0;i<optionsCount;i++){ if (v.options[i] !== selectedOptions[i]) return false; }
      return true;
    });
  }

  function showVariantMedia(variant, smooth){
    if (!variant) return;
    var mediaId = variantMediaMap[String(variant.id)];
    if (!mediaId) return;

    var track = root.querySelector('#gallerySlides');
    var slide = track ? track.querySelector('[data-media-id="' + mediaId + '"]') : null;
    if (!track || !slide) return;

    // Lors d'un choix effectué par la cliente, remonte immédiatement au
    // carrousel pour rendre le changement de photo visible. Le chargement
    // initial utilise smooth=false et ne déplace donc pas la page.
    if (smooth !== false){
      var gallery = root.querySelector('.pdp-gallery');
      if (gallery){
        gallery.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    }

    track.scrollTo({
      left: slide.offsetLeft - track.offsetLeft,
      behavior: smooth === false ? 'auto' : 'smooth'
    });
  }

  function updateVariantUI(){
    var v = findVariant();
    var btn = root.querySelector('#addToCartBtn');
    var stickyBtn = root.querySelector('#stickyAddToCartBtn');
    var priceEl = root.querySelector('#pdpPrice');
    if (v){
      basePrice = v.price;
      showVariantMedia(v, true);
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn){ btn.dataset.variantId = v.id; btn.disabled = !v.available; btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      if (stickyBtn){ stickyBtn.dataset.variantId = v.id; stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Ajouter' : 'Épuisé'; }
    } else if (btn){
      btn.disabled = true; btn.textContent = 'Indisponible dans cette combinaison';
      if (stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Indisponible'; }
    }
    updateBundlePrices();
    updateTotal();
  }

  root.querySelectorAll('[data-option-index]').forEach(function(group){
    var idx = parseInt(group.dataset.optionIndex, 10);
    group.querySelectorAll('.pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        group.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        selectedOptions[idx] = pill.dataset.value;
        updateVariantUI();
      });
    });
  });

  var currentVersion = null;
  var versionGroup = root.querySelector('#versionChoice');
  if (versionGroup){
    var firstPill = versionGroup.querySelector('.pill');
    if (firstPill) currentVersion = firstPill.dataset.value;
    versionGroup.querySelectorAll('.pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        versionGroup.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        currentVersion = pill.dataset.value;
      });
    });
  }

  var personalizationSection = root.querySelector('#personalizationSection');
  var personalizationLanguageField = root.querySelector('#personalizationLanguageField');
  var personalizationTextField = root.querySelector('#personalizationTextField');
  var personalizationInput = root.querySelector('#personalizationText');
  var personalizationError = root.querySelector('#personalizationError');
  var selectedPersonalizationLanguage = '';

  function clearPersonalizationError(){
    if (personalizationLanguageField) personalizationLanguageField.classList.remove('is-invalid');
    if (personalizationTextField) personalizationTextField.classList.remove('is-invalid');
    if (personalizationError){
      personalizationError.hidden = true;
      personalizationError.textContent = '';
    }
  }

  root.querySelectorAll('#personalizationLanguage .pill').forEach(function(pill){
    pill.addEventListener('click', function(){
      root.querySelectorAll('#personalizationLanguage .pill').forEach(function(item){
        item.classList.remove('selected');
        item.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('selected');
      pill.setAttribute('aria-checked', 'true');
      selectedPersonalizationLanguage = pill.dataset.value || '';
      if (personalizationInput){
        personalizationInput.dir = pill.dataset.direction === 'rtl' ? 'rtl' : 'ltr';
      }
      clearPersonalizationError();
    });
  });

  if (personalizationInput){
    personalizationInput.addEventListener('input', clearPersonalizationError);
  }

  function validatePersonalization(){
    clearPersonalizationError();
    var message = '';
    var invalidField = null;

    if (!selectedPersonalizationLanguage){
      message = root.dataset.languageError || 'Choisis d’abord la langue de la personnalisation.';
      invalidField = personalizationLanguageField;
    } else if (!personalizationInput || !personalizationInput.value.trim()){
      message = root.dataset.personalizationError || 'Écris le prénom ou le texte à personnaliser.';
      invalidField = personalizationTextField;
    }

    if (!message) return true;

    if (invalidField) invalidField.classList.add('is-invalid');
    if (personalizationError){
      personalizationError.textContent = message;
      personalizationError.hidden = false;
    }
    if (personalizationSection){
      personalizationSection.scrollIntoView({ behavior:'smooth', block:'center' });
    }
    if (invalidField === personalizationTextField && personalizationInput){
      window.setTimeout(function(){ personalizationInput.focus({ preventScroll:true }); }, 350);
    }
    return false;
  }

  var selectedQty = 1;
  var discountPercent = parseInt(root.dataset.discountPercent || '5', 10);
  function updateBundlePrices(){
    root.querySelectorAll('.bundle-tier').forEach(function(tier){
      var qty = parseInt(tier.dataset.qty, 10);
      var raw = basePrice * qty;
      var oldEl = tier.querySelector('[data-price-old]');
      var priceEl = tier.querySelector('[data-price]');
      if (qty === 3){
        var discounted = Math.round(raw * (100 - discountPercent) / 100);
        if (oldEl) oldEl.textContent = money(raw);
        if (priceEl) priceEl.textContent = money(discounted);
      } else if (priceEl) {
        priceEl.textContent = money(raw);
      }
    });
  }
  root.querySelectorAll('.bundle-tier').forEach(function(tier){
    tier.addEventListener('click', function(){
      root.querySelectorAll('.bundle-tier').forEach(function(t){ t.classList.remove('selected'); });
      tier.classList.add('selected');
      selectedQty = parseInt(tier.dataset.qty, 10);
      updateTotal();
    });
  });

  function updateTotal(){
    var totalEl = root.querySelector('#pdpTotal');
    var stickyPriceEl = root.querySelector('#stickyBarPrice');
    var raw = basePrice * selectedQty;
    if (selectedQty === 3){ raw = Math.round(raw * (100 - discountPercent) / 100); }
    if (totalEl) totalEl.textContent = money(raw);
    if (stickyPriceEl) stickyPriceEl.textContent = money(raw);
  }

  root.querySelectorAll('.acc-head').forEach(function(head){
    head.addEventListener('click', function(){
      var isOpen = head.getAttribute('aria-expanded') === 'true';
      var panel = root.querySelector('[data-acc-panel="'+head.dataset.acc+'"]');
      root.querySelectorAll('.acc-head').forEach(function(h){ h.setAttribute('aria-expanded','false'); });
      root.querySelectorAll('.acc-panel').forEach(function(p){ p.style.maxHeight = null; });
      if (!isOpen && panel){ head.setAttribute('aria-expanded','true'); panel.style.maxHeight = panel.scrollHeight + 'px'; }
    });
  });

  // Galerie principale : slides page par page, points, flèches desktop
  function setupCarousel(track, prevBtn, nextBtn, dotsContainer){
    if (!track) return;
    function currentIndex(){ return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function pauseInactiveVideos(){
      var activeIndex = currentIndex();
      Array.prototype.forEach.call(track.children, function(slide, index){
        if (index === activeIndex) return;
        slide.querySelectorAll('video').forEach(function(video){
          if (!video.paused) video.pause();
        });
        slide.querySelectorAll('iframe').forEach(function(frame){
          if (!frame.contentWindow) return;
          frame.contentWindow.postMessage(JSON.stringify({ event:'command', func:'pauseVideo', args:'' }), '*');
          frame.contentWindow.postMessage({ method:'pause' }, '*');
        });
      });
    }
    function updateArrows(){
      if (!prevBtn || !nextBtn) return;
      var idx = currentIndex();
      var lastIdx = track.children.length - 1;
      prevBtn.classList.toggle('is-disabled', idx <= 0);
      nextBtn.classList.toggle('is-disabled', idx >= lastIdx);
    }
    function goTo(index){
      var maxIndex = track.children.length - 1;
      var safeIndex = Math.max(0, Math.min(index, maxIndex));
      var slide = track.children[safeIndex];
      if (slide) track.scrollTo({ left:slide.offsetLeft - track.offsetLeft, behavior:'smooth' });
      window.setTimeout(updateArrows, 350);
    }
    if (prevBtn) prevBtn.addEventListener('click', function(){ goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ goTo(currentIndex() + 1); });

    var dotEls = null;
    if (dotsContainer){
      dotsContainer.innerHTML = '';
      Array.prototype.forEach.call(track.children, function(_, i){
        var dot = document.createElement('span');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', function(){ goTo(i); });
        dotsContainer.appendChild(dot);
      });
      dotEls = dotsContainer.querySelectorAll('.dot');
      track.addEventListener('scroll', function(){
        var idx = currentIndex();
        dotEls.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
        updateArrows();
      }, { passive:true });
    }
    track.addEventListener('scroll', pauseInactiveVideos, { passive:true });
    updateArrows();
    window.addEventListener('resize', updateArrows);
  }

  // Lien avis au-dessus du titre : défilement doux vers les preuves clientes.
  var reviewsLink = root.querySelector('.see-reviews-link');
  if (reviewsLink){
    reviewsLink.addEventListener('click', function(e){
      var target = root.querySelector(reviewsLink.getAttribute('href'));
      if (target){
        e.preventDefault();
        target.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    });
  }

  setupCarousel(
    root.querySelector('#gallerySlides'),
    root.querySelector('#galleryPrev'),
    root.querySelector('#galleryNext'),
    root.querySelector('#galleryDots')
  );
  showVariantMedia(findVariant(), false);
  setupCarousel(
    root.querySelector('#reviewsGrid'),
    root.querySelector('#reviewsPrev'),
    root.querySelector('#reviewsNext'),
    root.querySelector('#reviewsDots')
  );

  var addBtn = root.querySelector('#addToCartBtn');
  var csOverlay = root.querySelector('#csModalOverlay');

  function openCartDrawer(){
    if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function'){
      return Shopify.actions.openCart();
    }

    var cartDrawer = document.querySelector('cart-drawer-component');
    var themeDrawer = cartDrawer && cartDrawer.closest('theme-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function'){
      themeDrawer.open();
      return Promise.resolve();
    }

    console.warn('[Alhel] Le tiroir du panier est indisponible.');
    return Promise.reject(new Error('Le tiroir du panier est indisponible.'));
  }

  function performAddToCart(btn, onDone){
    if (!validatePersonalization()) return;
    var variantId = btn.dataset.variantId || (findVariant() || {}).id;
    if (!variantId) return;
    var items = [{ id: variantId, quantity: selectedQty, properties: {} }];
    if (currentVersion) items[0].properties['Objectif'] = currentVersion;
    items[0].properties['Langue de personnalisation'] = selectedPersonalizationLanguage;
    items[0].properties['Personnalisation'] = personalizationInput.value.trim();

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Ajout en cours...';

    var shopifyActions = window.Shopify && Shopify.actions;
    var addRequest;

    if (shopifyActions && typeof shopifyActions.updateCart === 'function'){
      var lines = items.map(function(item){
        var line = {
          merchandiseId: String(item.id),
          quantity: item.quantity || 1
        };

        var attributes = Object.keys(item.properties || {})
          .filter(function(key){
            return item.properties[key] !== null && item.properties[key] !== '';
          })
          .map(function(key){
            return { key:key, value:String(item.properties[key]) };
          });

        if (attributes.length) line.attributes = attributes;
        return line;
      });

      addRequest = shopifyActions.updateCart(
        { lines:lines },
        { event:{ context:'product' } }
      ).then(function(result){
        if (result && result.userErrors && result.userErrors.length){
          throw new Error(result.userErrors[0].message || 'Ajout au panier impossible.');
        }
        return result;
      });
    } else {
      addRequest = fetch(
        (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js',
        {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({ items:items })
        }
      ).then(function(response){
        if (!response.ok) throw new Error('Ajout au panier impossible.');
        return response.json();
      });
    }

    addRequest
      .then(function(){
        btn.disabled = false;
        btn.textContent = originalText;
        if (onDone) onDone();
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  if (addBtn){
    addBtn.addEventListener('click', function(){
      performAddToCart(addBtn, function(){
        if (csOverlay){ csOverlay.classList.add('open'); }
        else { openCartDrawer(); }
      });
    });
  }

  var stickyBtn = root.querySelector('#stickyAddToCartBtn');
  if (stickyBtn && addBtn){
    stickyBtn.addEventListener('click', function(){
      stickyBtn.dataset.variantId = addBtn.dataset.variantId;
      performAddToCart(stickyBtn, function(){
        if (csOverlay){ csOverlay.classList.add('open'); }
        else { openCartDrawer(); }
      });
    });
  }

  // Barre sticky mobile : apparaît quand le bouton principal sort de l'écran
  var stickyBar = root.querySelector('#alhelStickyBar');
  if (stickyBar && addBtn && 'IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(addBtn);
  }

  if (csOverlay){
    var csClose = root.querySelector('#csModalClose');
    var csContinue = root.querySelector('#csContinue');
    var csOpenCart = root.querySelector('#csOpenCart');
    if (csClose) csClose.addEventListener('click', function(){ csOverlay.classList.remove('open'); });
    if (csContinue) csContinue.addEventListener('click', function(){ csOverlay.classList.remove('open'); });
    if (csOpenCart) csOpenCart.addEventListener('click', function(){
      csOverlay.classList.remove('open');
      openCartDrawer();
    });
    csOverlay.addEventListener('click', function(e){ if (e.target === csOverlay) csOverlay.classList.remove('open'); });
  }

  updateBundlePrices();
  updateTotal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tafsir"] && !Shopify.designMode) return;
  try {
    
(function(){
  var genericProductSections = document.querySelectorAll('.alhel-pdp-wrap[id^="AlhelPdp-"]');
  var root = genericProductSections[genericProductSections.length - 1];
  if (!root || root.dataset.alhelInitialized === 'true') return;
  root.dataset.alhelInitialized = 'true';

  function parseJSON(value, fallback){
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  var variantsData = parseJSON(root.dataset.variants || '[]', []);
  var variantMediaMap = {};
  root.querySelectorAll('[data-variant-media-map] [data-variant-id]').forEach(function(item){
    if (item.dataset.variantMediaId){
      variantMediaMap[String(item.dataset.variantId)] = String(item.dataset.variantMediaId);
    }
  });
  var optionsCount = parseInt(root.dataset.optionsCount || '0', 10);
  var selectedOptions = parseJSON(root.dataset.selectedOptions || '[]', []);
  var basePrice = parseInt(root.dataset.basePrice || '0', 10);
  var cartUrl = root.dataset.cartUrl || '/cart';
  var addonVariantId = parseInt(root.dataset.addonVariantId || '0', 10);
  var addonPrice = parseInt(root.dataset.addonPrice || '0', 10);
  var plastificationVariantId = parseInt(root.dataset.plastificationVariantId || '0', 10);
  var plastificationPrice = parseInt(root.dataset.plastificationPrice || '0', 10);
  var addonAvailable = root.dataset.addonAvailable !== 'false';
  var plastificationAvailable = root.dataset.plastificationAvailable !== 'false';
  var addonSelected = false;
  var selectedAddonFinish = plastificationVariantId ? 'plastifiee' : 'classique';

  root.querySelectorAll('.product-video-slide').forEach(function(slide){
    var video = slide.querySelector('video');
    var playButton = slide.querySelector('.product-video-play');
    if (!video || !playButton) return;
    video.controls = false;
    playButton.addEventListener('click', function(){
      video.play().then(function(){ playButton.classList.add('is-hidden'); }).catch(function(){});
    });
    video.addEventListener('pause', function(){
      playButton.classList.remove('is-hidden');
    });
    video.addEventListener('ended', function(){ playButton.classList.remove('is-hidden'); });
  });

  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }

  function findVariant(){
    return variantsData.find(function(v){
      for (var i=0;i<optionsCount;i++){ if (v.options[i] !== selectedOptions[i]) return false; }
      return true;
    });
  }

  function showVariantMedia(variant, smooth){
    if (!variant) return;
    var mediaId = variantMediaMap[String(variant.id)];
    if (!mediaId) return;

    var track = root.querySelector('#gallerySlides');
    var slide = track ? track.querySelector('[data-media-id="' + mediaId + '"]') : null;
    if (!track || !slide) return;

    // Lors d'un choix effectué par la cliente, remonte immédiatement au
    // carrousel pour rendre le changement de photo visible. Le chargement
    // initial utilise smooth=false et ne déplace donc pas la page.
    if (smooth !== false){
      var gallery = root.querySelector('.pdp-gallery');
      if (gallery){
        gallery.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    }

    track.scrollTo({
      left: slide.offsetLeft - track.offsetLeft,
      behavior: smooth === false ? 'auto' : 'smooth'
    });
  }

  function updateVariantUI(){
    var v = findVariant();
    var btn = root.querySelector('#addToCartBtn');
    var stickyBtn = root.querySelector('#stickyAddToCartBtn');
    var priceEl = root.querySelector('#pdpPrice');
    if (v){
      basePrice = v.price;
      showVariantMedia(v, true);
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn){ btn.dataset.variantId = v.id; btn.disabled = !v.available; btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      if (stickyBtn){ stickyBtn.dataset.variantId = v.id; stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Ajouter' : 'Épuisé'; }
    } else if (btn){
      btn.disabled = true; btn.textContent = 'Indisponible dans cette combinaison';
      if (stickyBtn){ stickyBtn.disabled = true; stickyBtn.textContent = 'Indisponible'; }
    }
    updateBundlePrices();
    updateTotal();
  }

  root.querySelectorAll('[data-option-index]').forEach(function(group){
    var idx = parseInt(group.dataset.optionIndex, 10);
    group.querySelectorAll('.pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        group.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        selectedOptions[idx] = pill.dataset.value;
        updateVariantUI();
      });
    });
  });

  var currentVersion = null;
  var versionGroup = root.querySelector('#versionChoice');
  if (versionGroup){
    var firstPill = versionGroup.querySelector('.pill');
    if (firstPill) currentVersion = firstPill.dataset.value;
    versionGroup.querySelectorAll('.pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        versionGroup.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('selected'); });
        pill.classList.add('selected');
        currentVersion = pill.dataset.value;
      });
    });
  }

  var selectedQty = 1;
  var discountPercent = parseInt(root.dataset.discountPercent || '5', 10);
  function updateBundlePrices(){
    root.querySelectorAll('.bundle-tier').forEach(function(tier){
      var qty = parseInt(tier.dataset.qty, 10);
      var raw = basePrice * qty;
      var oldEl = tier.querySelector('[data-price-old]');
      var priceEl = tier.querySelector('[data-price]');
      if (qty === 3){
        var discounted = Math.round(raw * (100 - discountPercent) / 100);
        if (oldEl) oldEl.textContent = money(raw);
        if (priceEl) priceEl.textContent = money(discounted);
      } else if (priceEl) {
        priceEl.textContent = money(raw);
      }
    });
  }
  root.querySelectorAll('.bundle-tier').forEach(function(tier){
    tier.addEventListener('click', function(){
      root.querySelectorAll('.bundle-tier').forEach(function(t){ t.classList.remove('selected'); });
      tier.classList.add('selected');
      selectedQty = parseInt(tier.dataset.qty, 10);
      updateTotal();
    });
  });

  var addonCard = root.querySelector('#tafsirAddonCard');
  var addonCheckbox = root.querySelector('#tafsirAddonCheckbox');
  var finishPanel = root.querySelector('#tafsirFinishPanel');

  function setAddonSelected(selected){
    addonSelected = Boolean(selected) && addonAvailable;
    if (addonCard){
      addonCard.classList.toggle('selected', addonSelected);
      addonCard.setAttribute('aria-pressed', addonSelected ? 'true' : 'false');
    }
    if (addonCheckbox) addonCheckbox.checked = addonSelected;
    if (finishPanel) finishPanel.hidden = !addonSelected;
    updateTotal();
  }

  if (addonCard){
    addonCard.addEventListener('click', function(){ setAddonSelected(!addonSelected); });
    addonCard.addEventListener('keydown', function(event){
      if (event.key === 'Enter' || event.key === ' '){
        event.preventDefault();
        setAddonSelected(!addonSelected);
      }
    });
  }

  root.querySelectorAll('.tafsir-finish-option').forEach(function(option){
    option.addEventListener('click', function(){
      var requestedFinish = option.dataset.finish;
      if (requestedFinish === 'plastifiee' && (!plastificationVariantId || !plastificationAvailable)) return;
      selectedAddonFinish = requestedFinish;
      root.querySelectorAll('.tafsir-finish-option').forEach(function(item){ item.classList.remove('selected'); });
      option.classList.add('selected');
      updateTotal();
    });
  });

  function updateTotal(){
    var totalEl = root.querySelector('#pdpTotal');
    var stickyPriceEl = root.querySelector('#stickyBarPrice');
    var raw = basePrice * selectedQty;
    if (selectedQty === 3){ raw = Math.round(raw * (100 - discountPercent) / 100); }
    if (addonSelected){
      raw += addonPrice;
      if (selectedAddonFinish === 'plastifiee') raw += plastificationPrice;
    }
    if (totalEl) totalEl.textContent = money(raw);
    if (stickyPriceEl) stickyPriceEl.textContent = money(raw);
  }

  root.querySelectorAll('.acc-head').forEach(function(head){
    head.addEventListener('click', function(){
      var isOpen = head.getAttribute('aria-expanded') === 'true';
      var panel = root.querySelector('[data-acc-panel="'+head.dataset.acc+'"]');
      root.querySelectorAll('.acc-head').forEach(function(h){ h.setAttribute('aria-expanded','false'); });
      root.querySelectorAll('.acc-panel').forEach(function(p){ p.style.maxHeight = null; });
      if (!isOpen && panel){ head.setAttribute('aria-expanded','true'); panel.style.maxHeight = panel.scrollHeight + 'px'; }
    });
  });

  // Galerie principale : slides page par page, points, flèches desktop
  function setupCarousel(track, prevBtn, nextBtn, dotsContainer){
    if (!track) return;
    function currentIndex(){ return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function pauseInactiveVideos(){
      var activeIndex = currentIndex();
      Array.prototype.forEach.call(track.children, function(slide, index){
        if (index === activeIndex) return;
        slide.querySelectorAll('video').forEach(function(video){
          if (!video.paused) video.pause();
        });
        slide.querySelectorAll('iframe').forEach(function(frame){
          if (!frame.contentWindow) return;
          frame.contentWindow.postMessage(JSON.stringify({ event:'command', func:'pauseVideo', args:'' }), '*');
          frame.contentWindow.postMessage({ method:'pause' }, '*');
        });
      });
    }
    function updateArrows(){
      if (!prevBtn || !nextBtn) return;
      var idx = currentIndex();
      var lastIdx = track.children.length - 1;
      prevBtn.classList.toggle('is-disabled', idx <= 0);
      nextBtn.classList.toggle('is-disabled', idx >= lastIdx);
    }
    function goTo(index){
      var maxIndex = track.children.length - 1;
      var safeIndex = Math.max(0, Math.min(index, maxIndex));
      var slide = track.children[safeIndex];
      if (slide) track.scrollTo({ left:slide.offsetLeft - track.offsetLeft, behavior:'smooth' });
      window.setTimeout(updateArrows, 350);
    }
    if (prevBtn) prevBtn.addEventListener('click', function(){ goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ goTo(currentIndex() + 1); });

    var dotEls = null;
    if (dotsContainer){
      dotsContainer.innerHTML = '';
      Array.prototype.forEach.call(track.children, function(_, i){
        var dot = document.createElement('span');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', function(){ goTo(i); });
        dotsContainer.appendChild(dot);
      });
      dotEls = dotsContainer.querySelectorAll('.dot');
      track.addEventListener('scroll', function(){
        var idx = currentIndex();
        dotEls.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
        updateArrows();
      }, { passive:true });
    }
    track.addEventListener('scroll', pauseInactiveVideos, { passive:true });
    updateArrows();
    window.addEventListener('resize', updateArrows);
  }

  // Lien avis au-dessus du titre : défilement doux vers les preuves clientes.
  var reviewsLink = root.querySelector('.see-reviews-link');
  if (reviewsLink){
    reviewsLink.addEventListener('click', function(e){
      var target = root.querySelector(reviewsLink.getAttribute('href'));
      if (target){
        e.preventDefault();
        target.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    });
  }

  setupCarousel(
    root.querySelector('#gallerySlides'),
    root.querySelector('#galleryPrev'),
    root.querySelector('#galleryNext'),
    root.querySelector('#galleryDots')
  );
  showVariantMedia(findVariant(), false);
  setupCarousel(
    root.querySelector('#reviewsGrid'),
    root.querySelector('#reviewsPrev'),
    root.querySelector('#reviewsNext'),
    root.querySelector('#reviewsDots')
  );

  var addBtn = root.querySelector('#addToCartBtn');
  var csOverlay = root.querySelector('#csModalOverlay');

  function openCartDrawer(){
    if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function'){
      return Shopify.actions.openCart();
    }

    var cartDrawer = document.querySelector('cart-drawer-component');
    var themeDrawer = cartDrawer && cartDrawer.closest('theme-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function'){
      themeDrawer.open();
      return Promise.resolve();
    }

    console.warn('[Alhel] Le tiroir du panier est indisponible.');
    return Promise.reject(new Error('Le tiroir du panier est indisponible.'));
  }

  function performAddToCart(btn, onDone){
    var variantId = btn.dataset.variantId || (findVariant() || {}).id;
    if (!variantId) return;
    var items = [{ id: variantId, quantity: selectedQty, properties: {} }];
    if (currentVersion) items[0].properties['Objectif'] = currentVersion;
    if (addonSelected && addonVariantId){
      items.push({
        id: addonVariantId,
        quantity: 1,
        properties: {
          'Couleur': 'Noir',
          'Finition': selectedAddonFinish === 'plastifiee' ? 'Plastifiée' : 'Classique'
        }
      });
      if (selectedAddonFinish === 'plastifiee' && plastificationVariantId){
        items.push({ id: plastificationVariantId, quantity: 1, properties: {} });
      }
    }

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Ajout en cours...';

    var shopifyActions = window.Shopify && Shopify.actions;
    var addRequest;

    if (shopifyActions && typeof shopifyActions.updateCart === 'function'){
      var lines = items.map(function(item){
        var line = {
          merchandiseId: String(item.id),
          quantity: item.quantity || 1
        };

        var attributes = Object.keys(item.properties || {})
          .filter(function(key){
            return item.properties[key] !== null && item.properties[key] !== '';
          })
          .map(function(key){
            return { key:key, value:String(item.properties[key]) };
          });

        if (attributes.length) line.attributes = attributes;
        return line;
      });

      addRequest = shopifyActions.updateCart(
        { lines:lines },
        { event:{ context:'product' } }
      ).then(function(result){
        if (result && result.userErrors && result.userErrors.length){
          throw new Error(result.userErrors[0].message || 'Ajout au panier impossible.');
        }
        return result;
      });
    } else {
      addRequest = fetch(
        (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js',
        {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({ items:items })
        }
      ).then(function(response){
        if (!response.ok) throw new Error('Ajout au panier impossible.');
        return response.json();
      });
    }

    addRequest
      .then(function(){
        btn.disabled = false;
        btn.textContent = originalText;
        if (onDone) onDone();
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  if (addBtn){
    addBtn.addEventListener('click', function(){
      performAddToCart(addBtn, function(){
        if (csOverlay){ csOverlay.classList.add('open'); }
        else { openCartDrawer(); }
      });
    });
  }

  var stickyBtn = root.querySelector('#stickyAddToCartBtn');
  if (stickyBtn && addBtn){
    stickyBtn.addEventListener('click', function(){
      stickyBtn.dataset.variantId = addBtn.dataset.variantId;
      performAddToCart(stickyBtn, function(){
        if (csOverlay){ csOverlay.classList.add('open'); }
        else { openCartDrawer(); }
      });
    });
  }

  // Barre sticky mobile : apparaît quand le bouton principal sort de l'écran
  var stickyBar = root.querySelector('#alhelStickyBar');
  if (stickyBar && addBtn && 'IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(addBtn);
  }

  if (csOverlay){
    var csClose = root.querySelector('#csModalClose');
    var csContinue = root.querySelector('#csContinue');
    var csOpenCart = root.querySelector('#csOpenCart');
    if (csClose) csClose.addEventListener('click', function(){ csOverlay.classList.remove('open'); });
    if (csContinue) csContinue.addEventListener('click', function(){ csOverlay.classList.remove('open'); });
    if (csOpenCart) csOpenCart.addEventListener('click', function(){
      csOverlay.classList.remove('open');
      openCartDrawer();
    });
    csOverlay.addEventListener('click', function(e){ if (e.target === csOverlay) csOverlay.classList.remove('open'); });
  }

  updateBundlePrices();
  updateTotal();
})();

  } catch(e) { console.error(e); }
})();
})();
